module.exports = __webpack_public_path__ + "avai.91c30259018d4d8c6e89.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/webfonts/avai.ttf
// module id = ./src/assets/webfonts/avai.ttf
// module chunks = styles